import React, { Component } from "react";
import {Result, Button, Form, Icon, Input, Spin, Modal} from "antd";

import "./index.css";
import TextArea from "antd/es/input/TextArea";
import { Link } from "react-router-dom";
import {submitMoreInfosV2} from "../../../../api/api";
import ExclamationCircleOutlined from "@ant-design/icons/lib/icons/ExclamationCircleOutlined";

class NotAuthorized extends Component {
    constructor(props) {
        super(props);
        this.state = {
            requestId: sessionStorage.getItem("containerInfos_unchoice") ?
                JSON.parse(sessionStorage.getItem("containerInfos_unchoice")).requestId : null,
            errCodes: props.location.data ? props.location.data.errCodes : null,
            onSkipStatus:false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if (!sessionStorage.getItem("containerInfos_unchoice")) {
            this.props.history.push("/");
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        // let that = this;
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                let reqBody = {
                    requestId: this.state.requestId,
                    name: values.name,
                    contactNumber: values.contactNumber,
                    companyName: values.companyName,
                    remarks: values.remarks
                };
                // let res = await api.postAuthMoreInfo({
                //   requestId: this.props.location.data.requestId,
                //   contactNumber: values.contactNumber,
                //   companyName: values.companyName,
                //   remarks: values.comment
                // });
                this.setState({
                    onSkipStatus: true
                });

                let setSubmittedLoading = true;
                let submittedLoadingTime = 30;
                const timer = setInterval(() => {
                    submittedLoadingTime -= 1;
                }, 1000);

                setTimeout(() => {
                    clearInterval(timer);
                    this.setState({
                        onSkipStatus: false
                    });
                    if(setSubmittedLoading){
                        Modal.info({
                            content: `Something went wrong. Please try again.`,
                            okText: "Try again",
                            icon: <ExclamationCircleOutlined style={{ fontSize: '20px', color: 'red' }} />
                        });
                    }
                }, submittedLoadingTime * 1000);

                submitMoreInfosV2(reqBody).then(data => {
                    if (data.status === "success") {
                        setSubmittedLoading = false
                        this.setState({
                            onSkipStatus: false
                        });
                        this.props.history.push({
                            pathname: "/not-authorized-success",
                            containerInfos: data.containerInfos,
                            requestId: data.requestId
                        });
                    }
                })
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 5 },
            wrapperCol: { span: 16 }
        };

        return (
            <div>
                <Spin
                    style={{ fontSize: 40 }}
                    size="large"
                    tip="Processing..."
                    spinning={this.state.onSkipStatus}
                >
                <div className="main-grid">
                    <Result title="Sorry unable to proceed" />
                    <div className="content">
                        <div className="warning-content">
                            <p>
                                Your details do not seem to match those authorized for this
                                shipment. <br/>Please check that the BL or container number and
                                e-mail address are correct.
                            </p>
                            <p style={{ fontWeight: 600 }}>
                                Please note that if you are acting as an agent for the consignee
                                <br/>we will need to have authorization from the consignee first, 
                                this can be done by the consignee through this portal.
                            </p>
                            <p>
                                If you think that they are please complete the below and one of
                                our customer services team will be in contact with you to
                                resolve.
                            </p>
                        </div>
                        <div className="Contact">
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Item {...formItemLayout} label="Your name">
                                    {getFieldDecorator("name", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please input Your name!"
                                            }
                                        ]
                                    })(
                                        <Input
                                            prefix={
                                                <Icon
                                                    theme="filled"
                                                    style={{ color: "rgba(0,0,0,.25)" }}
                                                />
                                            }
                                        />
                                    )}
                                </Form.Item>

                                <Form.Item {...formItemLayout} label="Contact number">
                                    {getFieldDecorator("contactNumber", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please input your Contact number!"
                                            }
                                        ]
                                    })(
                                        <Input
                                            prefix={
                                                <Icon
                                                    theme="filled"
                                                    style={{ color: "rgba(0,0,0,.25)" }}
                                                />
                                            }
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item {...formItemLayout} label="Company name">
                                    {getFieldDecorator("companyName", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please input your Company name!"
                                            },
                                            {
                                                max: 150, message: "Cannot exceed 150 characters."
                                            }
                                        ]
                                    })(
                                        <Input
                                            prefix={
                                                <Icon
                                                    theme="filled"
                                                    style={{ color: "rgba(0,0,0,.25)" }}
                                                />
                                            }
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item {...formItemLayout} label="Remarks">
                                    {getFieldDecorator("remarks", {
                                        rules: []
                                    })(<TextArea rows={3} />)}
                                </Form.Item>
                                <Form.Item>
                                    <div className="justInCenterBottom">
                                        <Button htmlType="submit" type="primary">
                                            Submit
                                        </Button>
                                        <Link to="/">
                                            <Button style={{ marginLeft: 8 }} type="primary">
                                                Cancel
                                            </Button>
                                        </Link>
                                    </div>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </div>
                </Spin>
            </div>
        );
    }
}

export default Form.create({ name: "normal_login" })(NotAuthorized);
